import React, { Component } from 'react';
import { Row, Col, Button, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

import './style.css';
class Coffeecupsection extends Component {
    

    render() {
        let countryCode = JSON.parse(sessionStorage.getItem('countryCode'));
        return (
            <Container>
                <Row>
                    <Col className="coffee">
                        <div className="coffee-bg">
                            <div>
                                <h1><FormattedMessage id="main.coffee.title"
                                    defaultMessage="Coffee Cup Readings"
                                    description=""
                                    values="" /></h1>
                                <p className={countryCode.countryCode==="nl" ? "coffee-bg-p":null}><FormattedMessage id="main.coffee.paragraph"
                                    defaultMessage="Coffee Cup Reading is a divination or fortune-telling method that interprets patterns in coffee grounds."
                                    description=""
                                    values="" />
                                </p>
                                <div className="coffee-margin-top">
                                    <Link to="/Coffeecups"><Button outline className="coffee-btn">
                                        <FormattedMessage id="main.coffee.button"
                                            defaultMessage="View Yours Now"
                                            description=""
                                            values="" /></Button></Link>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        )
    }
}
export default Coffeecupsection;


// WEBPACK FOOTER //
// ./src/checkastronow/components/screens/coffeecupreading/coffeeCupSection.js